import React, { useContext } from 'react'
import {
  Box,
  ButtonSecondary,
  IconFolderPlusCircle,
  ShapeIcons,
} from '@creditas-ui/react'
import { Typography } from '@creditas-ui/react'
import { ModalContext } from 'shared/ui'

const AgentIndicateEmpty = () => {
  const { handleModalOpen } = useContext(ModalContext)
  return (
    <Box p="15vh 0" display="flex" justifyContent="center">
      <Box
        maxWidth={365}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Box mb={24}>
          <ShapeIcons size="x_small" Icon={IconFolderPlusCircle} />
        </Box>
        <Typography variant="headingSmRegular" color="neutral.90">
          Ainda não há nada aqui...
        </Typography>
        <Typography
          variant="bodyMdRegular"
          color="neutral.60"
          textAlign="center"
          mt="8px"
        >
          Mas não se preocupe, suas propostas criadas serão apresentadas nesta
          listagem.  Vamos começar?
        </Typography>
        <ButtonSecondary
          mt="24px"
          onClick={() => handleModalOpen()}
        >
          Criar proposta
        </ButtonSecondary>
      </Box>
    </Box>
  )
}

export { AgentIndicateEmpty }
